module.exports = __webpack_public_path__ + "img/pay-result-tip.8e91c1c2.png";